module.exports = __webpack_public_path__ + "static/signet-2ccd5c342b436bb7c41833e7aaa0204b.svg";